/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import { BulletList } from 'react-content-loader'
import moment from 'jalali-moment'

import '../../ShopList/list.scss'

import { useNavigate } from 'react-router-dom'

export default function index(data) {
  const [campaign, setCampaign] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    setCampaign(data.data)
  }, [data])

  return (
    <>
      <table className='table'>
        <thead>
          <tr>
            <th>نام کمپین</th>
            <th>تعداد فازها</th>
            <th>تاریخ شروع</th>
            <th>نوع کمپین</th>
            <th>عملیات</th>
          </tr>
        </thead>
        <tbody>
          {campaign ? campaign.map(item => (
              <tr key={item._id}>
                <td>{item.name}</td>
                <td>{JSON.parse(item.steps).length}</td>
                <td>{item.time}</td>
                <td>{moment(item.createdAt).locale('fa').format('YYYY/MM/DD HH:mm')}</td>
                <td>
                  <button onClick={() => navigate(`/cc/campaigns/detail/${item._id}`)}>ویرایش</button>
                </td>
              </tr>
            )) : <tr><td colSpan="5"><BulletList rtl style={{ width: '30%', rowspan: '5' }}/></td></tr>}
        </tbody>
      </table>
    </>
  );
}
